import { BaseEntity } from './baseEntity';
export class VariantMetaData extends BaseEntity {
  showBrief?: boolean;
  therapyExclusions?: string[];

  constructor(jsonData: any) {
    super(jsonData);
  }
}
